import { AbstractControl, FormGroup } from '@angular/forms';
import { checkBoxHelper, getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { isNilOrEmpty, nz } from '@shared/helpers/utils.helper';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { Utilities } from '@core/helpers/utilities';
import { debounceTime, merge, startWith } from 'rxjs';

export const getDatiBilancioGroup = (form: FormGroup): FormGroup => {
    return getGroup(form, formPaths.bilancio);
};

export const getDatiBilancioControl = (form: FormGroup, path: string) => {
    return getControl(form, `${formPaths.bilancio}.${path}`);
};

export const datiBilancioCkHelper = (
    form: FormGroup,
    targetPath: string,
    ckPath: string,
    ckTargetValue: number,
    subFormPath: string = formPaths.bilancio,
    suppCondition = true,
    errorStatus?: string
): void => {
    checkBoxHelper(form, targetPath, ckPath, ckTargetValue, subFormPath, suppCondition, errorStatus);
};

export const updateWarningGHISuperioriB = (
    form: FormGroup,
    store: Store<Revisione53State>,
    avanzoField: string,
    validaVerificaDelibereField: string,
    targetField: string
): void => {
    const schedaRistorniGroup = getGroup(form, `${formPaths.bilancio}.my_SchedaRistorni`);

    const avanzoControl = getControl(schedaRistorniGroup, avanzoField);
    const validaVerificaDelibereControl = getControl(schedaRistorniGroup, validaVerificaDelibereField);

    const result = nz(validaVerificaDelibereControl.value) > nz(avanzoControl.value) ? '1' : '0';

    patchWarningRistorni(form, store, targetField, result);
};

export const patchWarningRistorni = (form: FormGroup, store: Store<Revisione53State>, targetField: string, result: string): void => {
    const warningsRistorniGroup = getGroup(form, 'my_WarningsRistorni');
    const targetControl = getControl(warningsRistorniGroup, targetField);

    targetControl.patchValue(result, { emitEvent: false });

    updateVerbaleOnStore(store, (myVerbale) => {
        const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);

        myVerbaleClone.my_WarningsRistorni[targetField] = result;

        return myVerbaleClone;
    });
};

export const updateWarningGreaterThanField = (
    form: FormGroup,
    store: Store<Revisione53State>,
    flagField: string,
    sourceField: string,
    compareField: string,
    targetField: string,
    useFlag = true
): void => {
    const bilancioGroup = getGroup(form, formPaths.bilancio);
    const schedaRistorniGroup = getGroup(bilancioGroup, 'my_SchedaRistorni');

    const flagControl = getControl(bilancioGroup, flagField);
    const sourceControl = getControl(schedaRistorniGroup, sourceField);
    const compareControl = getControl(schedaRistorniGroup, compareField);

    const result =
        (!useFlag || flagControl.value === '1') && !isNilOrEmpty(sourceControl.value) && !isNilOrEmpty(compareControl.value) && nz(sourceControl.value) > nz(compareControl.value)
            ? '1'
            : '0';

    patchWarningRistorni(form, store, targetField, result);
};

export const registerWarningGreaterThanField = (
    form: FormGroup,
    store: Store<Revisione53State>,
    flagField: string,
    sourceField: string,
    compareField: string,
    targetField: string,
    useFlag = true
): void => {
    const bilancioGroup = getGroup(form, formPaths.bilancio);
    const schedaRistorniGroup = getGroup(bilancioGroup, 'my_SchedaRistorni');

    const flagControl = getControl(bilancioGroup, flagField);
    const sourceControl = getControl(schedaRistorniGroup, sourceField);
    const compareControl = getControl(schedaRistorniGroup, compareField);

    const controls = useFlag ? [flagControl, sourceControl, compareControl] : [sourceControl, compareControl];
    listenToControls(controls, () => {
        updateWarningGreaterThanField(form, store, flagField, sourceField, compareField, targetField, useFlag);
    });
};

export const listenToControls = (controls: AbstractControl[], callback: () => void): void => {
    merge(...controls.map((control) => control.valueChanges.pipe(startWith(control.value))))
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(callback);
};
